import { useState, useEffect } from 'react';
// ui
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from 'src/@/components/ui/table';
import { Switch } from 'src/@/components/ui/switch';
// components
import Iconify from 'src/components/Iconify';
import ModalServicos from './ModalServicos';
import ModalConfimacao from 'src/components/modal/ModalConfimacao';
// actions
import v2_actionServicos from 'src/actions/v2/cliente/cadastro/v2_actionServicos';
import v2_actionCriarServico from 'src/actions/v2/cliente/cadastro/v2_actionCriarServico';
import v2_actionEditarServico from 'src/actions/v2/cliente/cadastro/v2_actionEditarServico';
import v2_actionDeletarServico from 'src/actions/v2/cliente/cadastro/v2_actionDeletarServico';
import { CADASTRO_DESIGN as D } from '../Cadastro.design';

export default function ServicosComponent({ user }) {
    const [openModal, setOpenModal] = useState(false);
    const [modalConfimacao, setModalConfirmacao] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [servicos, setServicos] = useState([]);
    const [serviceId, setServiceId] = useState(null);
    const [loadingDelete, setLoadingDelete] = useState(false);

    const [dataService, setDataService] = useState({
        name: '',
        description: '',
        price: '',
        priceSale: '',
        time: 15,
        sale: false,
        status: false,
        instructions: ''
    });

    const fetchData = async () => {
        try {
            const response = await v2_actionServicos(user.clienteId);
            if (response.status === 200) {
                setServicos(response.data.data || []);
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleOpenModal = () => {
        setOpenModal(true);
        setIsEdit(false);
        setDataService({
            name: '',
            description: '',
            price: '',
            priceSale: '',
            time: 15,
            sale: false,
            status: true,
            instructions: ''
        });
    };

    const handleCloseModal = () => {
        setOpenModal(false);
        setIsEdit(false);
        setDataService({
            name: '',
            description: '',
            price: '',
            priceSale: '',
            time: 15,
            sale: false,
            status: false,
            instructions: ''
        });
    };

    const handleOpenEdit = (item) => {
        setDataService({
            name: item.name,
            description: item.description,
            price: item.price,
            priceSale: item.priceSale,
            time: item.time,
            sale: item.sale,
            status: item.status,
            instructions: item.instructions
        });
        setServiceId(item._id);
        setIsEdit(true);
        setOpenModal(true);
    };

    const handleSubmit = async () => {
        try {
            await v2_actionCriarServico(user.clienteId, dataService);
            fetchData();
            handleCloseModal();
        } catch (error) {
            console.log(error);
        }
    };

    const handleEditSubmit = async () => {
        try {
            let data = {
                scope: {
                    ...dataService
                }
            };
            await v2_actionEditarServico(serviceId, data);
            await fetchData();
            handleCloseModal();
            setServiceId(null);
        } catch (error) {
            console.log('error', error);
        }
    };

    const handleDelete = async () => {
        try {
            setLoadingDelete(true);
            await v2_actionDeletarServico(serviceId);
            await fetchData();
            setModalConfirmacao(false);
            setServiceId(null);
            setLoadingDelete(false);
        } catch (error) {
            setLoadingDelete(false);
            console.log('error', error);
        }
    };

    const handleToggleStatus = async (id, currentStatus) => {
        try {
            let data = {
                scope: {
                    status: !currentStatus
                }
            };
            await v2_actionEditarServico(id, data);
            fetchData();
        } catch (error) {
            console.log('error', error);
        }
    };

    const handleToggleSale = async (id, currentSale) => {
        try {
            let data = {
                scope: {
                    sale: !currentSale
                }
            };
            await v2_actionEditarServico(id, data);
            fetchData();
        } catch (error) {
            console.log(error);
        }
    };

    // Change Handlers
    const changeName = (e) => setDataService((prev) => ({ ...prev, name: e.target.value }));
    const changeDescription = (e) => setDataService((prev) => ({ ...prev, description: e.target.value }));
    const changePrice = (e) => setDataService((prev) => ({ ...prev, price: e.target.value }));
    const changePriceSale = (e) => setDataService((prev) => ({ ...prev, priceSale: e.target.value }));
    const changeTime = (e) => {
        let val = e.target.value;
        if (val < 15) val = 15;
        setDataService((prev) => ({ ...prev, time: val }));
    };
    const changeSale = (val) => setDataService((prev) => ({ ...prev, sale: val }));
    const changeInstructions = (e) => setDataService((prev) => ({ ...prev, instructions: e.target.value }));

    return (
        <div className={D.root} style={{ fontFamily: D.fontStack }}>
            <div className={D.stickyHeader}>
                <div className={D.container}>
                    <div className={D.topbar}>
                        <div className={D.topbarIdentity}>
                            <h1 className={D.title}>Serviços</h1>
                            <p className={D.subtitle}>Cadastre o que a empresa oferece e o tempo de cada atendimento.</p>
                        </div>
                        <div className={D.topbarActions}>
                            <button type="button" onClick={handleOpenModal} className={D.primaryButton}>
                                Novo serviço
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className={`${D.container} pt-6 ${D.pageBody}`}>
            <div className={D.stack}>
            <div className={D.sectionHeader}>
                <h2 className={D.sectionHeaderTitle}>Lista</h2>
                <p className={D.sectionHeaderSub}>{servicos.length} serviços cadastrados.</p>
            </div>

            {servicos.length === 0 ? (
                <div className={D.cardFlush}>
                    <div className={D.emptyWrap}>
                        <div className={D.emptyIcon}>
                            <Iconify icon="eva:briefcase-outline" width={28} />
                        </div>
                        <p className={D.emptyTitle}>Nenhum serviço encontrado</p>
                        <p className={D.emptyDesc}>Cadastre seus serviços para começar.</p>
                        <button type="button" className={`${D.link} mt-4`} onClick={handleOpenModal}>
                            Criar meu primeiro serviço
                        </button>
                    </div>
                </div>
            ) : (
                <div className={D.cardFlush}>
                    <Table>
                        <TableHeader>
                            <TableRow className="hover:bg-transparent">
                                <TableHead className={D.tableHead}>Nome</TableHead>
                                <TableHead className={D.tableHead}>Tempo</TableHead>
                                <TableHead className={D.tableHead}>Preço</TableHead>
                                <TableHead className={D.tableHead}>Preço promo</TableHead>
                                <TableHead className={D.tableHead}>Promoção</TableHead>
                                <TableHead className={D.tableHead}>Status</TableHead>
                                <TableHead className={`${D.tableHead} text-right`}>Ações</TableHead>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {servicos.map((row) => (
                                <TableRow key={row._id} className={D.tableRow}>
                                    <TableCell className="font-semibold text-[#18181b]">{row.name}</TableCell>
                                    <TableCell className="text-[#71717a]">{row.time} min</TableCell>
                                    <TableCell className="text-[#71717a]">R$ {row.price}</TableCell>
                                    <TableCell className="text-[#71717a]">
                                        {row.priceSale ? `R$ ${row.priceSale}` : '—'}
                                    </TableCell>
                                    <TableCell>
                                        <Switch className={D.switch} checked={row.sale} onCheckedChange={() => handleToggleSale(row._id, row.sale)} />
                                    </TableCell>
                                    <TableCell>
                                        <Switch className={D.switch} checked={row.status} onCheckedChange={() => handleToggleStatus(row._id, row.status)} />
                                    </TableCell>
                                    <TableCell className="text-right">
                                        <div className="flex justify-end gap-1.5">
                                            <button type="button" className={D.iconButton} onClick={() => handleOpenEdit(row)}>
                                                <Iconify icon="eva:edit-2-outline" width={16} />
                                            </button>
                                            <button
                                                type="button"
                                                className={D.iconButtonDanger}
                                                onClick={() => { setServiceId(row._id); setModalConfirmacao(true); }}
                                            >
                                                <Iconify icon="eva:trash-2-outline" width={16} />
                                            </button>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>
            )}

            <ModalConfimacao
                open={modalConfimacao}
                onClose={() => {
                    setModalConfirmacao(false);
                    setServiceId(null);
                }}
                onConfirm={handleDelete}
                loadingFinalizar={loadingDelete}
                mensagem={'Deseja mesmo excluir?'}
            />

            <ModalServicos
                open={openModal}
                onClose={handleCloseModal}
                dataService={dataService}
                isEdit={isEdit}
                changeName={changeName}
                changeDescription={changeDescription}
                changePrice={changePrice}
                changePriceSale={changePriceSale}
                changeTime={changeTime}
                changeSale={changeSale}
                changeInstructions={changeInstructions}
                onSubmit={handleSubmit}
                onEdit={handleEditSubmit}
            />
            </div>
            </div>
        </div>
    );
}
